import { Icon, Style } from 'ol/style';
import { baseStyle } from '@vendor/libs/maps/styles/base';
export const unaffiliatedApiaryStyle = (resolution = 1000, muted = false) => {
    return new Style({
        image: new Icon({
            src: '/assets/img/maps/pins/apiaries/hive_entity.png',
            anchor: [0.5, 0.5],
            scale: (1 / Math.pow(resolution, 1 / 6)) * 0.1 * (muted ? 0.65 : 1),
        }),
    });
};
export default (feature, resolution) => {
    return baseStyle(feature, resolution, () => {
        if (resolution > 750) {
            return new Style({});
        }
        return unaffiliatedApiaryStyle(resolution, feature.get('muted'));
    });
};
